import { useLocation, useParams } from "../navigation";
import { usePatents } from "../patents/PatentsProvider";
import { fullFamily, fullMember } from "../search/fullResult";
import { family_member, patent_family } from "../data";
import { useClaims } from "../claims/ClaimsProvider";
import { useTasks } from "../tasks/TasksProvider";
import { useCosts } from "../costs/CostsProvider";

export function useAssetLocation() {
    const location = useLocation()
    const params = useParams()

    const { memberByReference, familyById, familyByReference, membersByFamilyId } = usePatents()
    const {aggregatedClaims} = useClaims()
    const {tasksLookUp} = useTasks()
    const {costsByEntity} = useCosts()

    if (location.pathname.startsWith('/patents/portfolio/member')) {
        const member = memberByReference[params.internalReference]
        const claimsByMemberId = aggregatedClaims[member?.patentFamilyId]?.claimsByMemberId ?? {}
        return { entity: family_member, member: fullMember({member, familyById, claimsByMemberId, tasksLookUp}) }
    } if (location.pathname.startsWith('/patents/portfolio/family')) {
        const family = fullFamily({family: familyByReference[params.internalReference], membersByFamilyId, tasksLookUp, costsByEntity})
        return { entity: patent_family, family }
    } else {
        return {}
    }
}

// export function 